
function NoPage() {
  return (
    <div class="d-flex align-items-center justify-content-center vh-100">
      <div class="text-center">
        <h1 class="display-1 fw-bold">404</h1>
        <p class="fs-3"> <span class="text-danger">Opps!</span> La página no fue encontrada.</p>
        <p class="lead">
          La página donde intentas acceder, no existe.. 😅
        </p>
        <a href="/" class="btn btn-primary">Inicio</a>
      </div>
    </div>
  );
}

export default NoPage;
